import { useQuery } from '@tanstack/react-query';
import apiClient from '../services/api';

export interface Activity {
  id: string;
  type: 'objet' | 'zone' | 'box' | 'site' | 'batiment' | 'piece';
  action: 'created' | 'updated' | 'deleted' | 'moved' | 'inventoried';
  entityId: string;
  entityName: string;
  userId: string;
  userName?: string;
  userEmail: string;
  details?: string;
  createdAt: string;
}

export const useActivities = (limit = 20) => {
  return useQuery({
    queryKey: ['activities', limit],
    queryFn: async (): Promise<Activity[]> => {
      // Pour l'instant, on génère des activités mock depuis les objets récents
      // TODO: Implémenter endpoint backend /activities
      
      const response = await apiClient.get('/objets?limit=10&page=1');
      const objets = response.data.objets || [];
      
      // Convertir les objets en activités
      const activities: Activity[] = objets.map((objet: any) => ({
        id: `activity-${objet.id}`,
        type: 'objet' as const,
        action: 'created' as const,
        entityId: objet.id,
        entityName: objet.nom,
        userId: objet.userId,
        userName: objet.user?.name,
        userEmail: objet.user?.email,
        details: `Catégorie: ${objet.categorie}`,
        createdAt: objet.createdAt,
      }));

      return activities;
    },
    staleTime: 30 * 1000, // 30 secondes
    refetchInterval: 60 * 1000, // Refresh toutes les minutes
  });
};

